import React, {Component} from 'react';
import loremIpsum from 'lorem-ipsum';

import 'sass/ui-kit-page.scss';

import Loading from '../components/Loading';

class UiKitPage extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        let gridTestItems = [];
        let colors = ['pink', 'green', 'azure'];
        for (let i = 0; i < 12; i++) {
            gridTestItems.push(<div key={i}><div style={{background: colors[i % 3]}}>{loremIpsum({count: (i % 3) * 5, unit: 'words'})}</div></div>)
        }

        return (
            <div className="ui-kit-page ui-kit-base">

                <h1 className="ui-header">H1 header</h1>
                <h2 className="ui-header">H2 header</h2>
                <h3 className="ui-header">H3 header</h3>

                <button className="ui-button">A button</button>
                <button className="ui-button" disabled="disabled">A disabled button</button>
                <button className="ui-button ui-mini">A mini button</button>
                <button className="ui-button ui-mini primary disabled">A mini primary disabled button</button>
                <button className="ui-button primary">Primary button</button>
                <button className="ui-button primary" disabled="disabled">Primary disabled button</button>

                <div>
                    <input type="radio" name="radio" value="1" className="ui-radio" id="radio-1" defaultChecked="checked"/><label htmlFor="radio-1">A radio checked</label>
                    <input type="radio" name="radio" value="2" className="ui-radio" id="radio-2"/><label htmlFor="radio-2">A radio</label>
                </div>


                <div>
                    <input type="radio" name="radio2" value="1" className="ui-radio-2" id="radio2-1" defaultChecked="checked"/><label htmlFor="radio2-1">A radio 2 checked</label>
                    <input type="radio" name="radio2" value="2" className="ui-radio-2" id="radio2-2"/><label htmlFor="radio2-2">A radio 2</label>
                </div>

                <div>
                    <div className="ui-selector">
                        <div className="active">Date</div>
                        <div>Popularity</div>
                    </div>
                </div>

                <Loading>Loading...</Loading>

                <div className="ui-responsive-grid single-row grid-test">{gridTestItems}</div>
            </div>
        );
    }
}

export default UiKitPage;


// WEBPACK FOOTER //
// ./src/containers/UiKitPage.js